module.exports = __webpack_public_path__ + "img/IMG-20200623-WA0031.f253d9d3.jpg";